import { generatePath } from "react-router-dom";
import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const getShopReviews = async (shopId, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const response = await axios.get(
    `${generatePath(apiRoutes.GET_SHOP_REVIEWS, { shopId })}?${qs}`,
  );
  return response.data;
};

export const getPublicShop = async (shopId) => {
  const response = await axios.get(
    generatePath(apiRoutes.GET_PUBLIC_SHOP, { shopId }),
  );
  return response.data;
};

export const getShopByHandle = async (handle) => {
  // react-router-dom's generatePath can't substitute a param sharing a segment
  // with static text (e.g. ":handle" in "/shop/@:handle") — build the URL directly.
  const response = await axios.get(`/shop/@${encodeURIComponent(handle)}`);
  return response.data;
};

export const getShopProducts = async (shopId, queryParams) => {
  const qs = queryParams ? new URLSearchParams(queryParams).toString() : "";
  const response = await axios.get(
    `${generatePath(apiRoutes.GET_SHOP_PRODUCTS, { shopId })}?${qs}`,
  );
  return response.data;
};

export const createShop = async (shopInfo) => {
  const formattedShopInfo = formatShopInfoForSubmission(shopInfo);
  const newShop = await axios.post(apiRoutes.OPEN_SHOP, formattedShopInfo);
  return newShop.data;
};

export const getShopForCreator = async (shopId) => {
  const response = await axios.get(
    generatePath(apiRoutes.ADMIN_SHOP, { shopId }),
  );
  return response.data;
};

export const getUserShops = async (queryParams) => {
  let stringifiedQueryString;
  if (queryParams) {
    stringifiedQueryString = new URLSearchParams(queryParams).toString();
  }
  const response = await axios.get(
    `${apiRoutes.GET_ADMIN_SHOPS}?${stringifiedQueryString || ""}`,
  );
  return response.data;
};

export const updateShop = async (shopInfo) => {
  const formattedShopInfo = formatShopInfoForSubmission(shopInfo);
  const updatedShop = await axios.patch(
    generatePath(apiRoutes.ADMIN_SHOP, { shopId: formattedShopInfo.id }),
    formattedShopInfo,
  );
  return updatedShop.data;
};

const formatShopInfoForSubmission = (shopInfo) => {
  shopInfo.address.postalCode = String(shopInfo.address.postalCode);
  return shopInfo;
};
